import { useUser } from '@liveblocks/react'

import { cn } from '@dc-shared-web/lib'
import { Avatar } from '@/dc-shared-web/src'

const getInitials = (name: string) => {
  if (!name) {
    return ''
  }

  const splitName = name.split(' ')

  if (splitName.length === 1) {
    return splitName[0].charAt(0)
  }

  return `${splitName[0].charAt(0)}${splitName[splitName.length - 1].charAt(0)}`
}

export default function NotificationResolvedUserAvatar({
  userId,
  className,
  color,
  size,
}: {
  userId: string
  className?: string
  color?: 'neutral' | 'blue' | 'green' | 'purple'
  size?: 'xs' | 'sm' | 'md' | 'lg'
}) {
  const { user } = useUser(userId)

  return (
    <div className={className}>
      {user ? (
        <Avatar
          fallback={getInitials(user.name)}
          size={size ?? 'sm'}
          fallbackColor={color}
        />
      ) : (
        <div
          className={cn(
            'tw-w-8 tw-h-8 tw-rounded-full tw-animate-skeleton-shimmer',
            className
          )}
        />
      )}
    </div>
  )
}
